import * as R from "ramda";
import { RootState } from "../../store";
import { nullOrValue, sortChronologically } from "../../helper/utils";

export const selectLatestRecord = (state: RootState) =>
    nullOrValue(R.head(sortChronologically(state.history.records)));